import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import SquareIcon from 'src/registry/components/blocks/SquareIcon';
import { tableMessages } from 'src/registry/components/table/utils/messages';
import { Button } from 'src/registry/ui/Button';
import {
    Dialog,
    DialogBody,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogSeparator,
    DialogTitle,
    DialogTrigger,
} from 'src/registry/ui/Dialog';

export type DataTableSearchInfoProps = {
    fields: string[];
};

export function DataTableSearchInfo({ fields }: DataTableSearchInfoProps) {
    const { formatMessage, locale } = useIntl();

    const fieldsText = new Intl.ListFormat(locale, { style: 'long', type: 'disjunction' }).format(fields);

    return (
        <Dialog>
            <DialogTrigger asChild>
                <Button variant="ghost" size="icon" aria-label={formatMessage(tableMessages.searchInfo)}>
                    <FontAwesomeIcon
                        icon={faCircleQuestion}
                        className="stroke-current stroke-[2px] text-[22px] text-gray-600"
                    />
                </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-lg sm:gap-4">
                <DialogHeader>
                    <div className="flex gap-2">
                        <SquareIcon icon={faSearch} />
                        <div>
                            <DialogTitle>{formatMessage(tableMessages.search)}</DialogTitle>
                            <DialogDescription>{formatMessage(tableMessages.searchInfo)}</DialogDescription>
                        </div>
                    </div>
                </DialogHeader>
                <DialogSeparator />
                <DialogBody>
                    <p className="text-gray-500">
                        {formatMessage(tableMessages.searchByFields, { fields: fieldsText })}
                    </p>
                </DialogBody>
                <DialogSeparator />
                <DialogFooter>
                    <DialogClose asChild>
                        <Button>{formatMessage(tableMessages.ok)}</Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
